const colors = {
  WHITE_100: '#FFFFFF',
  WHITE_80: 'rgba(255, 255, 255, 0.8)',
  WHITE_60: 'rgba(255, 255, 255, 0.6)',
  WHITE_30: 'rgba(255, 255, 255, 0.3)',
  WHITE_20: 'rgba(255, 255, 255, 0.2)',
  WHITE_15: 'rgba(255, 255, 255, 0.15)',
  WHITE_10: 'rgba(255, 255, 255, 0.1)',
  WHITE_HOVER: 'rgba(255, 255, 255, 0.15)',

  DISABLED: '#BBC0c6', // DO WE NEED THIS
  TEXT_DISABLED: '#C0D7D5',

  CAPTION: '#222222',
  BLACK_100: '#000000',
  BLACK_60: 'rgba(0, 0, 0, 0.6)',
  BLACK_25: 'rgba(0, 0, 0, 0.25)',
  BLACK_30: 'rgba(0, 0, 0, 0.3)',
  BLACK_40: 'rgba(0, 0, 0, 0.4)',
  BLACK_10: 'rgba(0, 0, 0, 0.1)',

  GRAY: '#E5E5E5',
  LIGHT_GRAY: '#F4F4F1',
  MEDIUM_GRAY: '#C6C6C2',
  MEDIUM_GRAY_2: '#C4C4C4',
  MEDIUM_GRAY_3: '#CCCCCC',
  MEDIUM_GRAY_4: '#D4D4D4',
  DARK_GRAY: '#555555',

  NAVY: '#1C2D40',
  NAVY_30: 'rgba(28, 45, 64, 0.3)',
  NAVY_80: 'rgba(28, 45, 64, 0.8)',
  FADED_NAVY: '#465D77',
  FADED_NAVY_HOVER: 'rgba(70, 93, 119, 0.2)',
  NAVY_GRADIENT: 'linear-gradient(121.14deg, #36506D 0%, #1C2D40 100%)',

  MARINE_BLUE: '#2A5699',
  LIGHT_BLUE: '#47A1F3',

  LIGHT_SKY_BLUE: '#B8E0EC',
  SKY_BLUE: '#92C7D6',

  MUTED_SEAFOAM: '#B6C6C5', // rgba(182, 198, 197, 1)
  SEAFOAM: '#9DDCD6', // rgba(157, 220, 214, 1)
  DARK_SEAFOAM: '#5AC4B9', // rgba(90, 196, 185, 1)
  SEAFOAM_SUPPLEMENTAL: '#2C7B74', // rgba(44, 123, 116, 1)
  SEAFOAM_SUPPLEMENTAL_80: 'rgba(44, 123, 116, 0.8)',
  SEAFOAM_SUPPLEMENTAL_30: 'rgba(44, 123, 116, 0.3)',
  SEAFOAM_HOVER: 'rgba(44, 123, 116, 0.3)',
  SEAFOAM_HOVER_80: 'rgba(44, 123, 116, 0.8)',

  GREEN: '#1D6F42',
  LIGHT_SUCCESS: '#0E8049',
  DARK_SUCCESS: '#55ECA4',

  SUN_YELLOW_30: 'rgba(252, 205, 72, 0.3)',
  SUN_YELLOW: '#FCCB42',
  SUN_YELLOW_SUPPLEMENTAL: '#FCCD48',

  CORAL: '#FB6C58',
  DEEP_ORANGE: '#e65100',

  LIGHT_BIND_INCOMPLETE: '#E5A100',
  DARK_BIND_INCOMPLETE: '#FCCB42',

  LIGHT_ERROR: '#D62B13',
  DARK_ERROR: '#FF5942',

  RED: '#F40F02',
  LIGHT_RED: '#D04423',

  BORDER_LIGHT_GRAY: '#e0e0e0',

  // Insureon Events preset theme (mirrors --preset-primary / --preset-primary-dark in oktaSignInWidget.css)
  INSUREON_PRESET_PRIMARY: '#3B2DBE',
  INSUREON_PRESET_LIGHT: '#6B5EDB',
  INSUREON_PRESET_DARK: '#271FA0',
};

export const darkThemeColors = {
  YELLOW: '#FFDD7D',
  TOOLTIP_BACKGROUND: '#54667b',
};
export default colors;

// export const customThemeExample = {
//   BACKGROUND: 'hsl(0 32% 28% / 1)',
//   BACKGROUND_LIGHT: '#894c4c',

//   RED_LIGHT: '#8d6060',
//   RED_2: '#673c3c',
//   RED_3: '#442222',

//   SECONDARY: '#CCCCCC',
//   OTHER_COLOR: '#FFDD7D',
// };

export const customThemeExample = {
  BACKGROUND: 'hsl(310.15deg 24.24% 30.92%)',
  BACKGROUND_LIGHT: '#95479df5', //

  RED_LIGHT: '#9d33a8',
  RED_2: '#9d33a8',
  RED_3: '#9d33a8',

  PURPLE: '#7c5f77',

  SECONDARY: '#CCCCCC',
  OTHER_COLOR: '#FFDD7D',
};
